
<ng-container *ngIf="isLoaded">
  <div class="modal-close-btn" (click)="closeModal()">X</div>
  <div class="card mb-3">
    <div class="card-body">
      <div class="pt-4 pb-2">
        <h5 class="card-title text-center pb-0 fs-4">Редакция на Организация</h5>
        <p class="text-center small">Моля, направете нужните промени</p>
      </div>
      <div style="display: flex; justify-content: end;">
        <button type="button" style="margin-right: 10px;" class="btn btn-primary" (click)="onTokenShow()"><i class="bi bi-check-circle"></i> Токени</button>
        </div>
      <form *ngIf="isLoaded" [formGroup]="Form" class="row g-3 needs-validation" (ngSubmit)="onSubmit()">
        <div class="col-12">
          <label for="title" class="form-label">Име</label>
          <input type="text" formControlName="title" class="form-control" id="title" value="{{editOrg.title}}">
        </div>
        <div class="col-12">
          <label for="vat" class="form-label">ЕИК</label>
          <input type="text"
                 formControlName="vat"
                 class="form-control"
                 id="vat"
                 maxlength="9"
                 pattern="^[0-9]{9}$"
                 placeholder="Въведете 9-цифрен ЕИК">
        </div>
        <div class="form-group mt-4">
          <label for="responseType">Вид Обратна Връзка</label>
          <div class="payment-wrapper">
            <select class="form-control" id="responseType" formControlName="responseType">
              <option *ngFor="let method of responseTypes" [value]="method.value">
                {{GetCyrilicRequestType(method.value)}}
              </option>
            </select>
          </div>
        </div>
        <div class="col-12">
          <app-bank-selector [selectedBankDetails]="editOrg.bankDetails" (selectedAccount)="onBankAccountSelected($event)" />
        </div>
        <div class="col-12">
          <label for="description" class="form-label">Описание</label>
          <input type="text" formControlName="description" class="form-control" id="description" value="{{editOrg.description}}">
        </div>
        <div class="col-12">
          <label for="role" class="form-label">Тип</label>
          <select formControlName="organizationalType" class="form-select">
            <option value="" disabled>Изберете Тип</option>
            <option *ngFor="let orgType of orgTypes" [value]="getValue(OrganizationTypes[orgType])" [selected]="onSelect(OrganizationTypes[orgType])">{{ orgType.replace('_',' ') }}</option>
          </select>
        </div>
        <!-- Radio button group for selecting Parent/Child -->
        <div class="col-12">
          <label class="form-label">Вид на Организацията</label>
          <div class="form-check">
            <input class="form-check-input" type="radio" formControlName="parentChildType" value="parent" id="parentRadio" (change)="onOrgTypeChange('parent')">
            <label class="form-check-label" for="parentRadio">Родител</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="radio" formControlName="parentChildType" value="child" id="childRadio" (change)="onOrgTypeChange('child')">
            <label class="form-check-label" for="childRadio">Дъщерна</label>
          </div>
        </div>

        <!-- Dropdown for selecting the parent organization (shown if "Child" is selected) -->
        <div class="col-12" *ngIf="isChildSelected">
          <label for="parentOrg" class="form-label">Изберете Основна организация</label>
          <select formControlName="parentOrg" class="form-select" id="parentOrg">
            <option *ngFor="let org of organizations" [value]="org.id">{{ org.title }}</option>
          </select>
        </div>

        <div class="col-12">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" formControlName="enableVik" id="enableVik" [(ngModel)]="isVikEnabled">
            <label class="form-check-label" for="enableVik">Модул ВИК</label>
          </div>
        </div>
        <div class="col-12">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="enableServiceProvider" formControlName="enableService" [(ngModel)]="isServiceProviderEnabled" (change)="onCheckboxChange()">
            <label class="form-check-label" for="enableServiceProvider">Модул Услуги</label>
          </div>
        </div>
        <div class="col-12">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="enableEGovAutomation" formControlName="enableEGovAutomation" [(ngModel)]="isEGovAutomationEnabled">
            <label class="form-check-label" for="enableEGovAutomation">еГов Автоматизация</label>
          </div>
        </div>
        <div class="col-12 mt-3">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="enableMessageDetailsSync" [(ngModel)]="isMessageDetailsSyncEnabled" [ngModelOptions]="{standalone: true}">
            <label class="form-check-label" for="enableMessageDetailsSync">
              Синхронизация на детайли за съобщения
              <small class="text-muted d-block">Когато е изключено, съобщенията от МЕУ няма да бъдат маркирани като отворени</small>
            </label>
          </div>
        </div>
        <div *ngIf="isServiceProviderEnabled" class="col-12">
          <label for="selectedAgent" class="form-label">Посредник</label>
          <select formControlName="selectedAgent" class="form-select">
            <option value="0" disabled>Не е избран Посредник</option>
            <option *ngFor="let agent of agents" [value]="agent.idAgent">{{ agent.agentName.replace('_',' ') }}</option>
          </select>
        </div>
        <div *ngIf="isServiceProviderEnabled" class="col-12">
          <label for="selectedProvider" class="form-label">Доставчик</label>
          <select formControlName="selectedProvider" class="form-select">
            <option value="0" disabled>Не е Избран Доставчик</option>
            <option *ngFor="let provider of providers" [value]="provider.idServiceProvider">{{ provider.serviceProviderName.replace('_',' ') }}</option>
          </select>
        </div>
        <hr />
        <div class="col-12">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="includePayment" formControlName="includePayment">
            <label class="form-check-label" for="includePayment">
              Отключване на Разплащане
            </label>
          </div>
        </div>
        <div class="col-12">
          <button class="btn btn-primary w-100" type="submit" [disabled]="!Form.valid">Промени</button>
        </div>
      </form>
    </div>
  </div>

</ng-container>
